import axios from 'axios';
import { requests } from '../constants/config';

export const FETCH_COMPANY_NAMES = 'FETCH_COMPANY_NAMES';
export const FETCH_COMPANY_NAMES_SUCCESS = 'FETCH_COMPANY_NAMES_SUCCESS';
export const FETCH_COMPANY_NAMES_ERROR = 'FETCH_COMPANY_NAMES_ERROR';

export const fetchCompanyNames = () => {
    return {
        type: FETCH_COMPANY_NAMES
    };
};

export const fetchCompanyNamesSuccess = (data) => {
    return {
        type: FETCH_COMPANY_NAMES_SUCCESS,
        payload: data
    };
};

export const fetchComapnyNamesError = (error) => {
    return {
        type: FETCH_COMPANY_NAMES_ERROR,
        payload: error
    };
};

export const getComapanyNames = (rfc) => {
    return (dispatch) => {
        dispatch(fetchCompanyNames());
        return axios.get(requests.vendorCompanyNames + rfc)
            .then((res) => {
                dispatch(fetchCompanyNamesSuccess(res.data.relationships));
                localStorage.setItem('companyNames', JSON.stringify(res.data.relationships));
            })
            .catch((err) => {
                console.log(err);
                dispatch(fetchComapnyNamesError('No se pudieron cargar las razones sociales.'));
            });
    };
};
